import TabList from "@components/TabList";
import AJAX from "@core/ajax";
import GeoLocation from "@core/geolocation";
import FavoriteRestaurant from "@core/favoriteRestaurant";
import { STATE } from "@core/state";
import windmill from "@core/windmill";
import { OPEN_CLASSNAME as NAV_OPEN_CLASSNAME, CLOSE_CLASSNAME as NAV_CLOSE_CLASSNAME } from "@ui/site-nav";
import { $, html } from "@utils/dom";
import { on, off } from "@utils/listener";
import { motion_reduced } from "@utils/mobile";

const PANEL_OPEN_CLASSNAME = "--js-favorite-restaurant-panel-opened";
const PANEL_CLOSE_CLASSNAME = "--js-favorite-restaurant-panel-closing";

class SiteHeader {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.favoriteRestaurantBtn = new FavoriteRestaurantBtn( $('.site-header__favoriteRestaurantBtn', this.el) );
    this.favoriteRestaurantPanel = new FavoriteRestaurantPanel( $('.site-header__favoriteRestaurantPanel', this.el), this.emitter );
    this.favoriteRestaurantCloseBtn = $('.site-header__favoriteRestaurantCloseBtn', this.el);
    //this.nav = $('.site-header__nav', this.el);
    this.menuLink = $('.site-header__nav li.site-header__menuLink > a', this.el);
    this.orderLink = $('.site-header__orderLink', this.el);
    this.bookingLink = $('.site-header__bookingLink', this.el);
    this.superMenu = new SuperMenu( $('.site-header__nav > ul > li.menu-item-has-children', this.el), this.emitter );

    this._initialized = false;
    this._started = false;
    this._bookingURL = null;
    this._orderURL = null;
    this._skipFavoriteRestaurantChange = false;

    this._onGeoLocationChange = this._onGeoLocationChange.bind(this);
    this._onFavoriteRestaurantChange = this._onFavoriteRestaurantChange.bind(this);
    this._onGetClosestRestaurantResponse = this._onGetClosestRestaurantResponse.bind(this);
    this._onGetRestaurantResponse = this._onGetRestaurantResponse.bind(this);
    this._onFavoriteRestaurantBtnClick = this._onFavoriteRestaurantBtnClick.bind(this);
    this._onFavoriteRestaurantCloseBtnClick = this._onFavoriteRestaurantCloseBtnClick.bind(this);
    this._onBackdropClick = this._onBackdropClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    //this._onSiteScroll = this._onSiteScroll.bind(this);
    this._onWindmillExit = this._onWindmillExit.bind(this);
    this._onFavoriteRestaurantPanelOpen = this._onFavoriteRestaurantPanelOpen.bind(this);
    this._onFavoriteRestaurantPanelClose = this._onFavoriteRestaurantPanelClose.bind(this);
    this._onSuperMenuOpen = this._onSuperMenuOpen.bind(this);
  }

  init() {
    if( this._initialized ) return;
    this._initialized = true;

    if( this.bookingLink ) this._bookingURL = this.bookingLink.href;
    if( this.orderLink ) this._orderURL = this.orderLink.href;

    this._bindEvents();
  }
  start() {
    if( this._started ) return;
    this._started = true;

    // fetch favorite restaurant panel content saved from Favorite Restaurant ID
    if( FavoriteRestaurant.slug ) this._onFavoriteRestaurantChange();
    // fetch favorite restaurant from saved GeoLocation
    else if( GeoLocation.latitude && GeoLocation.longitude ) this._onGeoLocationChange();
  }

  _bindEvents() {
    GeoLocation.on('change', this._onGeoLocationChange);
    FavoriteRestaurant.on('change', this._onFavoriteRestaurantChange);

    this.emitter.on('FavoriteRestaurant.open', this._onFavoriteRestaurantPanelOpen);
    this.emitter.on('FavoriteRestaurant.close', this._onFavoriteRestaurantPanelClose);
    this.emitter.on('SiteNav.open', this._onSuperMenuOpen);
    this.emitter.on('SiteBackdrop.click', this._onBackdropClick);

    if( this.favoriteRestaurantBtn ) on(this.favoriteRestaurantBtn.el, 'click', this._onFavoriteRestaurantBtnClick);
    if( this.favoriteRestaurantCloseBtn ) on(this.favoriteRestaurantCloseBtn, 'click', this._onFavoriteRestaurantCloseBtnClick);
    if( this.el ) on(window, "keydown", this._onKeyDown);

    windmill.on('exiting', this._onWindmillExit);
  }
  _refreshActionBtn(btn, newURL, fallbackURL) {
    btn.href = newURL !== undefined ? newURL : fallbackURL;

    const wasHidden = btn.getAttribute('aria-hidden') === 'true';
    const willBeHidden = btn.href.endsWith('#');

    btn.setAttribute('aria-hidden', willBeHidden);

    if( wasHidden !== willBeHidden ) {
      btn.animate({
        opacity: [0, 1]
      }, {
        duration: 500,
        delay: 350,
        fill: 'backwards',
        easing: 'linear',
      });
    }
  }

  _onGeoLocationChange() {
    // bail early if favorite restaurant is already defined
    if( FavoriteRestaurant.slug ) return;

    // get nearest restaurant from geolocation
    const { latitude, longitude } = GeoLocation;
    AJAX.get('get_closest_restaurant', { lat: latitude, lng: longitude }).then(this._onGetClosestRestaurantResponse);
  }
  _onFavoriteRestaurantChange() {
    // bail early if we ask to skip next run
    if( this._skipFavoriteRestaurantChange ) {
      this._skipFavoriteRestaurantChange = false;
      return;
    }

    // fetch favorite restaurant panel content
    AJAX.get('get_restaurant', { slug: FavoriteRestaurant.slug }).then(this._onGetRestaurantResponse);
  }
  _onGetClosestRestaurantResponse(response) {
    // bail early if favorite restaurant is already defined
    if( FavoriteRestaurant.slug ) return;

    // bail early if there is an error
    if( response.error ) return;

    // prevent favorite restaurant change event to perform
    this._skipFavoriteRestaurantChange = true;

    // save favorite restaurant
    FavoriteRestaurant.slug = response.slug;

    // manually update favorite restaurant panel content
    this._onGetRestaurantResponse(response);
  }
  _onGetRestaurantResponse(response) {
    // bail early if favorite restaurant panel doesn't exists
    if( !this.favoriteRestaurantPanel ) return;

    // emit response to favorite restaurant
    this.emitter.emit('FavoriteRestaurant.response', response);

    // bail early if there is an error
    if( response.error ) return;

    // get restaurant name + phone
    const { name, phone, orderURL, bookingURL, menuURL, post } = response;

    // update panel & button content
    this.favoriteRestaurantPanel.update( post );
    this.favoriteRestaurantBtn.update(name, phone);

    // update favorite restaurant essentials URL for global access
    FavoriteRestaurant.update(menuURL, orderURL, bookingURL);
    html.classList.add('--favorite-restaurant-selected');

    // update menu link url
    if( this.menuLink ) this.menuLink.href = menuURL;

    //const before = rect(this.nav);

    // update order & booking link url
    if( this.orderLink ) this._refreshActionBtn(this.orderLink, orderURL, this._orderURL);
    if( this.bookingLink ) this._refreshActionBtn(this.bookingLink, bookingURL, this._bookingURL);

    //const after = rect(this.nav);

    // if nav has moved during update, FLIP animation
    /*
    if( before.left !== after.left ) {
      [ ...$$(':scope > ul > li > a, :scope > ul > li > button', this.nav) ].forEach(el => {
        el.animate({
          transform: [`translateX(${before.left - after.left}px)`, `translateX(0px)`]
        }, {
          duration: 650,
          fill: 'backwards',
          easing: 'cubic-bezier(.45,0,.24,1)'
        });
      });
    }
    */
  }
  _onFavoriteRestaurantBtnClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.favoriteRestaurantPanel.toggle();
  }
  _onFavoriteRestaurantCloseBtnClick() {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.favoriteRestaurantPanel.close();
  }
  _onBackdropClick() {
    // close favorite restaurant panel if opened
    if( this.favoriteRestaurantPanel.opened ) this.favoriteRestaurantPanel.close();

    // close supermenu if opened
    if( this.superMenu && this.superMenu.opened ) this.superMenu.close();
  }
  _onKeyDown(event) {
    // bail early if key isn't Escape/Esc
    if( event.key !== "Escape" && event.key !== "Esc" ) return;

    // close favorite restaurant panel if opened
    if( this.favoriteRestaurantPanel.opened ) this.favoriteRestaurantPanel.close();

    // close supermenu if opened
    if( this.superMenu && this.superMenu.opened ) this.superMenu.close();
  }
  /*
  _onSiteScroll() {
    // close favorite restaurant panel if opened
    if( this.favoriteRestaurantPanel.opened ) this.favoriteRestaurantPanel.close();

    // close supermenu if opened
    if( this.superMenu && this.superMenu.opened ) this.superMenu.close();
  }
  */
  _onWindmillExit() {
    // close favorite restaurant panel if opened
    if( this.favoriteRestaurantPanel.opened ) this.favoriteRestaurantPanel.close();

    // close supermenu if opened
    if( this.superMenu && this.superMenu.opened ) this.superMenu.close();
  }

  _onFavoriteRestaurantPanelOpen() {
    if( this.superMenu && this.superMenu.opened ) this.superMenu.close();

    this.favoriteRestaurantBtn.el.setAttribute('inert', true);
    this.favoriteRestaurantBtn.el.setAttribute('aria-expanded', true);
    this.favoriteRestaurantCloseBtn.setAttribute('aria-expanded', true);
    this.favoriteRestaurantCloseBtn.removeAttribute('inert');
  }
  _onFavoriteRestaurantPanelClose() {
    this.favoriteRestaurantCloseBtn.setAttribute('inert', true);
    this.favoriteRestaurantCloseBtn.setAttribute('aria-expanded', false);
    this.favoriteRestaurantBtn.el.setAttribute('aria-expanded', false);
    this.favoriteRestaurantBtn.el.removeAttribute('inert');
  }
  _onSuperMenuOpen() {
    if( this.favoriteRestaurantPanel && this.favoriteRestaurantPanel.opened ) this.favoriteRestaurantPanel.close();
  }
}

class FavoriteRestaurantPanel {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.scheduleGroup = null;
    this.scheduleBtn = null;
    this.tablist = null;

    this._opened = false;

    this._onScheduleClick = this._onScheduleClick.bind(this);
  }

  update( html ) {
    if( this.scheduleBtn ) off(this.scheduleBtn, 'click', this._onScheduleClick);
    if( this.tablist ) this.tablist.destroy();

    this.scheduleBtn = null;
    this.tablist = null;

    this.el.innerHTML = html;
    this.scheduleGroup = $('.favorite-restaurant__scheduleGroup', this.el);
    this.scheduleBtn = $('.favorite-restaurant__scheduleBtn', this.el);
    this.tablist = $('.schedules__tablist', this.el);

    if( this.scheduleBtn ) on(this.scheduleBtn, 'click', this._onScheduleClick);
    if( this.tablist ) this.tablist = new TabList(this.tablist);
  }
  open() {
    if( this._opened ) return;
    this._opened = true;

    // dispatch to state current status
    STATE.dispatch("FAVORITE_RESTAURANT_NAV", this._opened);

    this.el.scrollTo({ top: 0, behavior: 'instant' });
    this.el.removeAttribute('inert');
    this.emitter.emit('FavoriteRestaurant.open');

    if( html.classList.contains(PANEL_CLOSE_CLASSNAME) ) html.classList.replace(PANEL_CLOSE_CLASSNAME, PANEL_OPEN_CLASSNAME);
    else html.classList.add(PANEL_OPEN_CLASSNAME);
  }
  close() {
    if( !this._opened ) return;
    this._opened = false;

    // dispatch to state current status
    STATE.dispatch("FAVORITE_RESTAURANT_NAV", this._opened);

    this.el.setAttribute('inert', true);
    this.emitter.emit('FavoriteRestaurant.close');

    html.classList.replace(PANEL_OPEN_CLASSNAME, PANEL_CLOSE_CLASSNAME);
  }
  toggle() {
    if( this._opened ) this.close();
    else this.open();
  }

  _onScheduleClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.scheduleGroup.classList.toggle('--js-open');
  }

  // getter - setter
  get opened() { return this._opened; }
}

class FavoriteRestaurantBtn {
  constructor(el) {
    this.el = el;
    this.name = $('.site-header__favoriteRestaurantBtn__name', this.el);
    this.phone = $('.site-header__favoriteRestaurantBtn__phone', this.el);
  }

  update(name, phone) {
    if( this.name ) this.name.textContent = name;
    if( this.phone ) this.phone.textContent = phone;

    this.el.setAttribute('aria-label', this.el.dataset.label.replace('%s', name).replace('%s', phone));
    this.el.removeAttribute('aria-hidden');
    this.el.removeAttribute('inert');
  }
}

class SuperMenu {
  constructor(el, emitter) {
    if( !el ) return;

    this.el = el;
    this.emitter = emitter;
    this.btn = $(':scope > a, :scope > button', this.el);
    this.submenu = $(':scope > ul', this.el);

    this._opened = false;

    this._onClick = this._onClick.bind(this);
    this._onCloseCompleted = this._onCloseCompleted.bind(this);

    this._init();
    this._bindEvents();
  }

  _init() {
    this.submenu.setAttribute('id', `site-nav__submenu`);
    this.submenu.setAttribute('aria-expanded', false);
    this.submenu.setAttribute('inert', true);
    this.btn.setAttribute('aria-controls', this.submenu.id);
  }
  _bindEvents() {
    on(this.btn, 'click', this._onClick);
  }

  _onClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.toggle();
  }

  open() {
    if( this._opened ) return;
    this._opened = true;

    // dispatch to state current status
    STATE.dispatch("SITE_NAV", this._opened);

    const favoriteRestaurantNavOpened = STATE.favoriteRestaurantNav;

    // site-nav open
    this.emitter.emit("SiteNav.open");

    // remove close animation completion listener
    off(this.submenu, 'transitionend', this._onCloseCompleted);

    setTimeout(() => {
      // set submenu visible for screen readers
      this.submenu.removeAttribute("inert");

      // inform <html> that submenu is opened
      if( html.classList.contains(NAV_CLOSE_CLASSNAME) ) html.classList.replace(NAV_CLOSE_CLASSNAME, NAV_OPEN_CLASSNAME);
      else html.classList.add(NAV_OPEN_CLASSNAME);
    }, favoriteRestaurantNavOpened ? 200 : 0);
  }
  close() {
    if( !this._opened ) return;
    this._opened = false;

    // dispatch to state current status
    STATE.dispatch("SITE_NAV", this._opened);

    // close submenu
    this.emitter.emit("SiteNav.close");

    // make sure event listener is not duplicated
    off(this.submenu, 'transitionend', this._onCloseCompleted);
    on(this.submenu, 'transitionend', this._onCloseCompleted);

    // inform <html> that submenu is closed
    html.classList.replace(NAV_OPEN_CLASSNAME, NAV_CLOSE_CLASSNAME);

    // if user prefer reduced motion, go to close transition callback immediately
    if( motion_reduced ) this._onCloseCompleted({ target: this.submenu });
  }
  toggle() {
    if( this._opened ) this.close();
    else this.open();
  }

  _onCloseCompleted(event) {
    if (event.target !== this.submenu || this._opened === true) return;

    // remove event listener
    off(this.submenu, 'transitionend', this._onCloseCompleted);

    // hide submenu from screen readers
    this.submenu.setAttribute("inert", true);
  }

  // getter - setter
  get opened() { return this._opened; }
}

export default SiteHeader;
